import React from "react";

const CameraHelp = ({ onStartRecording }) => {
    return (
        <div className=" tw-w-[80%] tw-p-8  tw-bg-white tw-rounded-lg">
            <h1 className="tw-text-2xl tw-font-bold tw-text-black tw-mb-6 tw-text-center">Help Section: Camera Issues</h1>

            {/* What to Do If the Camera Isn't Working */}
            <section className="tw-mb-8">
                <h2 className="tw-text-xl tw-font-bold tw-mb-3 ">What to Do If the Camera Isn't Working:</h2>
                <div className="">
                    <h1 className="tw-font-semibold tw-mb-3 tw-text-medium_text">Check Permissions:</h1>
                    <ul className="tw-list-disc tw-text-[14px] tw-pl-6 tw-mb-4 tw-text-medium_text">
                        <li>Ensure your browser or device has permission to access the camera.</li>
                        <li>
                            If prompted, click "Allow" when asked to use the camera. You can also manually enable camera permissions through your
                            browser or device settings.
                        </li>
                    </ul>
                </div>
            </section>

            {/* Refresh the Page */}
            <section className="tw-mb-8">
                <h2 className="tw-text-[16px] tw-font-semibold tw-mb-3 tw-text-medium_text">Refresh the Page:</h2>
                <div className="tw-pl-4">
                    <ul className="tw-list-disc tw-text-[14px] tw-pl-6 tw-mb-4 tw-text-medium_text">
                        <li>
                            Sometimes, refreshing the page can solve issues related to camera access. Press Ctrl + F5 (Windows) or Cmd + R (Mac) to
                            refresh.
                        </li>
                    </ul>
                </div>
            </section>

            {/* Try a Different Browser */}
            <section className="tw-mb-8">
                <h2 className="tw-text-[16px] tw-font-semibold tw-mb-3 tw-text-medium_text">Try a Different Browser:</h2>
                <div className="tw-pl-4">
                    <ul className="tw-list-disc tw-text-[14px] tw-pl-6 tw-mb-4 tw-text-medium_text">
                        <li>
                            If the camera isn't working on your current browser, try switching to another browser (e.g., Chrome, Firefox, Safari).
                        </li>
                    </ul>
                </div>
            </section>

            {/* Close Other Applications */}
            <section className="tw-mb-8">
                <h2 className="tw-text-[16px] tw-font-semibold tw-mb-3 tw-text-medium_text">Close Other Applications:</h2>
                <div className="tw-pl-4">
                    <ul className="tw-list-disc tw-text-[14px] tw-pl-6 tw-mb-4 tw-text-medium_text">
                        <li>
                            Make sure other applications are not using your camera. Close apps like Zoom, Skype, or other services that may be
                            accessing your camera.
                        </li>
                    </ul>
                </div>
            </section>

            {/* Restart Your Device */}
            <section className="tw-mb-8">
                <h2 className="tw-text-[16px] tw-font-semibold tw-mb-3 tw-text-medium_text">Restart Your Device:</h2>
                <div className="tw-pl-4">
                    <ul className="tw-list-disc tw-text-[14px] tw-pl-6 tw-mb-4 tw-text-medium_text">
                        <li>For the best results, restarting your device can often resolve technical issues with the camera.</li>
                    </ul>
                </div>
            </section>

            {/* Use a Different Device */}
            <section className="tw-mb-8">
                <h2 className="tw-text-[16px] tw-font-semibold tw-mb-3 tw-text-medium_text">Use a Different Device:</h2>
                <div className="tw-pl-4">
                    <ul className="tw-list-disc tw-text-[14px] tw-pl-6 tw-mb-4 tw-text-medium_text">
                        <li>
                            If you're still unable to access your camera, try using a different device, such as a mobile phone, tablet, or another
                            computer.
                        </li>
                    </ul>
                </div>
            </section>

            {/* Need Further Assistance */}
            <section className="tw-mb-8">
                <h2 className="tw-text-[18px] tw-font-semibold tw-mb-3">Need Further Assistance?</h2>
                <div className="tw-pl-4">
                    <p className="tw-mb-2 tw-text-[14px] tw-text-medium_text">
                        If you're experiencing persistent issues, contact our support team for help. You can reach us via:
                    </p>
                    <ul className="tw-list-disc tw-text-[14px] tw-pl-6 tw-text-medium_text tw-space-y-2">
                        <li>Customer support: Click the chat icon at the bottom of the screen.</li>
                        <li>
                            Email Support: <span className="tw-text-text_link">support@airebrokers.com</span>
                        </li>
                    </ul>
                </div>
            </section>

            {/* Start Recording Button */}
            <div className="tw-w-full tw-flex tw-items-center tw-justify-center">
                <button
                    onClick={onStartRecording}
                    className="tw-w-fit tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-py-3 tw-px-20 tw-rounded-md tw-font-thin tw-hover:bg-orange-600 tw-transition-colors"
                >
                    Start Recording
                </button>
            </div>
        </div>
    );
};

export default CameraHelp;
